<style>
    .mx-datepicker {
        display: block !important;
        width: 100%;
    }

    .modal-body .select2, .modal-dialog .select2 {
        width: 100% !important;
    }
</style>

<template>
    <content>
        <Header></Header>
        <Body :menu="menu"></Body>
        <Footer></Footer>
    </content>
</template>

<script>
import Header from '../core/Header'
import Footer from '../core/footer/Footer'
import Body from '../core/Body'
export default {
  name: 'Admin',
  data () {
    return {
      loaded: 0
    }
  },
  computed: {
    menu: {
      get: function () {
        return this.$store.state.loading.menu
      },
      set: function (val) {
        return this.$store.state.loading.menu
      }
    }
  },
  watch: {
    'menu': {
      handler (val) {

      },
      deep: true
    }
  },
  mounted: function () {
    window.$('#m_ver_menu').customScrollbar({
      skin: 'default-skin',
      hScroll: false
    })
  },
  created: function () {
    if (localStorage.getItem('menu') !== this.$store.state.loading.menu) {
      if (localStorage.getItem('menu') === null) {
        this.loadMenu()
      } else {
        this.$store.commit('loading/setMenu', JSON.parse(localStorage.getItem('menu')))
        this.menu = this.$store.state.loading.menu
      }
    } else {
      this.menu = this.$store.state.loading.menu
    }
  },
  methods: {
    loadMenu () {
      this.apiUrl = process.env.API_URL + '/' + process.env.API_ENDPOINT + '/admin/menu'

      this.$http
        .get(this.apiUrl + `/admin-menu`, {
          'headers': {
            'Authorization': 'Bearer ' + localStorage.getItem('token'),
            'language': this.$store.state.loading.language
          }
        }).then(res => {
          self.menu = res.data.data

          this.$store.commit('loading/setMenu', self.menu)
        }).catch(res => {

        })
    }
  },
  components: {Body, Footer, Header}
}
</script>



// WEBPACK FOOTER //
// src/components/admin/Admin.vue